<template>
	<div class="fs-panel">
		<div class="fs-title">食品安全综合指数</div>

		<div class="fs-main">
			<div class="fs-gauge" ref="gauge"></div>
			<div class="fs-info">
				<div class="fs-level">{{ levelText }}</div>
				<div class="fs-desc">
					综合评分基于抽检合格率、产品合格率、<br />
					质量投诉率、投诉处理率四项指标加权计算
				</div>
			</div>
		</div>

		<div class="fs-subs">
			<div class="fs-sub" :class="sub.level" v-for="sub in subs" :key="sub.label">
				<div class="fs-sub-label">{{ sub.label }}</div>
				<div class="fs-sub-value">{{ sub.value }}<span class="fs-sub-unit">%</span></div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		name: 'FoodSafetyPanel',
		data() {
			return {
				score: 95.2,
				levelText: '优秀',
				subs: [{
						label: '抽检合格率',
						value: '97.6',
						level: 'good'
					},
					{
						label: '产品合格率',
						value: '99.2',
						level: 'good'
					},
					{
						label: '质量投诉率',
						value: '16.0',
						level: 'warn'
					},
					{
						label: '投诉处理率',
						value: '100',
						level: 'good'
					}
				],
				myChart: null
			}
		},
		mounted() {
			this.initChart()
			window.addEventListener('resize', this.resize)
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.resize)
			if (this.myChart) {
				this.myChart.dispose()
				this.myChart = null
			}
		},
		methods: {
			resize() {
				if (this.myChart) this.myChart.resize()
			},
			initChart() {
				this.myChart = echarts.init(this.$refs.gauge)
				const option = {
					series: [{
						type: 'gauge',
						startAngle: 200,
						endAngle: -20,
						min: 0,
						max: 100,
						radius: '100%',
						center: ['50%', '60%'],
						progress: {
							show: true,
							width: 10,
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
										offset: 0,
										color: '#0066ff'
									},
									{
										offset: 1,
										color: '#00ffcc'
									}
								]),
								shadowColor: 'rgba(0, 212, 255, 0.5)',
								shadowBlur: 8
							}
						},
						axisLine: {
							lineStyle: {
								width: 10,
								color: [
									[1, 'rgba(0, 60, 130, 0.4)']
								]
							}
						},
						pointer: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							show: false
						},
						axisLabel: {
							show: false
						},
						detail: {
							valueAnimation: true,
							fontSize: 26,
							fontWeight: 'bold',
							color: '#fff',
							offsetCenter: [0, '0%'],
							formatter: '{value}'
						},
						data: [{
							value: this.score
						}]
					}]
				}
				this.myChart.setOption(option)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fs-panel {
		width: 100%;
		box-sizing: border-box;
		padding: 12px 14px;
		display: flex;
		flex-direction: column;
		border-radius: 6px;
	}

	.fs-title {
		font-size: 14px;
		color: #cce8ff;
		margin-bottom: 10px;
		padding-left: 8px;
		border-left: 3px solid #00d4ff;
		letter-spacing: 1px;
		flex-shrink: 0;
	}

	.fs-main {
		display: flex;
		align-items: center;
		gap: 14px;
		margin-bottom: 12px;
	}

	.fs-gauge {
		width: 160px;
		height: 140px;
		flex-shrink: 0;
	}

	.fs-info {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.fs-level {
		display: inline-block;
		padding: 2px 10px;
		background: linear-gradient(90deg, rgba(0, 255, 153, 0.2), rgba(0, 212, 255, 0.2));
		border: 1px solid rgba(0, 255, 153, 0.5);
		border-radius: 3px;
		color: #00ffcc;
		font-size: 12px;
		width: fit-content;
	}

	.fs-desc {
		font-size: 10px;
		color: #88bbdd;
		line-height: 1.6;
	}

	.fs-subs {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 8px;
	}

	.fs-sub {
		text-align: center;
		padding: 6px 2px;
		background: rgba(0, 60, 130, 0.2);
		border-radius: 4px;
		border: 1px solid rgba(0, 180, 255, 0.15);
	}

	.fs-sub-label {
		font-size: 10px;
		color: #88bbdd;
		margin-bottom: 3px;
	}

	.fs-sub-value {
		font-size: 16px;
		font-weight: bold;
		color: #fff;
	}

	.fs-sub-unit {
		font-size: 10px;
		font-weight: normal;
		color: #88bbdd;
	}

	.fs-sub.good .fs-sub-value {
		color: #00ff99;
	}

	.fs-sub.warn .fs-sub-value {
		color: #ffaa33;
	}
</style>
